import React from 'react';
import Skeleton from './Skeleton';

const SkeletonClientProfile = ({ className = '', ...props }) => {
  return (
    <div
      aria-label="Loading client profile"
      className={`skeleton-client-profile ${className}`}
      role="status"
      {...props}
    >
      {/* Header Section */}
      <div className="skeleton-dashboard-card">
        <div className="skeleton-dashboard-header">
          <div>
            <Skeleton variant="text" className="title" width="40%" />
            <Skeleton variant="text" className="subtitle" width="25%" />
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <Skeleton variant="button" />
            <Skeleton variant="button" />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <Skeleton variant="avatar" className="large" />
          <div style={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="35%" />
          </div>
        </div>
      </div>

      {/* Info Cards Grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1rem',
          marginBottom: '1rem'
        }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="skeleton-card">
            <Skeleton variant="text" className="subtitle" width="50%" />
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="70%" />
          </div>
        ))}
      </div>

      {/* Notes Section */}
      <div className="skeleton-dashboard-card">
        <div className="skeleton-dashboard-header">
          <Skeleton variant="text" className="title" width="30%" />
          <Skeleton variant="button" />
        </div>
        <div className="skeleton-dashboard-content">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} style={{ marginBottom: '1rem' }}>
              <Skeleton variant="text" width="100%" />
              <Skeleton variant="text" width="90%" />
              <Skeleton variant="text" width="75%" />
              <div
                style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}
              >
                <Skeleton variant="text" width="20%" />
                <Skeleton variant="text" width="15%" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* History Timeline */}
      <div className="skeleton-dashboard-card">
        <div className="skeleton-dashboard-header">
          <Skeleton variant="text" className="title" width="25%" />
        </div>
        <div className="skeleton-dashboard-content">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}
            >
              <Skeleton variant="avatar" className="small" style={{ marginRight: '1rem' }} />
              <div style={{ flex: 1 }}>
                <Skeleton variant="text" width="70%" />
                <Skeleton variant="text" width="50%" />
              </div>
              <Skeleton variant="text" width="15%" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonClientProfile;
